<template>
  <div class="nav">
    <ul class="">
      <li class="homepage_router">
        <router-link to="/home" exact>
            <svg viewBox="0 0 24 24" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3103 1.77586C11.6966 1.40805 12.3034 1.40805 12.6897 1.77586L20.6897 9.39491L23.1897 11.7759C23.5896 12.1567 23.605 12.7897 23.2241 13.1897C22.8433 13.5896 22.2103 13.605 21.8103 13.2241L21 12.4524V20C21 21.1046 20.1046 22 19 22H14H10H5C3.89543 22 3 21.1046 3 20V12.4524L2.18966 13.2241C1.78972 13.605 1.15675 13.5896 0.775862 13.1897C0.394976 12.7897 0.410414 12.1567 0.810345 11.7759L3.31034 9.39491L11.3103 1.77586ZM5 10.5476V20H9V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V20H19V10.5476L12 3.88095L5 10.5476ZM13 20V15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15V20H13Z"/> </svg>
        </router-link>
      </li>
      <li class="sportsbook_router"><router-link class="sportsbook_router" to="/sportsbook" data-title="Spor Bahisleri"><span>Spor Bahisleri</span></router-link></li>
      <li class="live_router"><router-link class="live_router" to="/live" data-title="Canlı Bahis"><span>Canlı Bahis</span></router-link></li>
      <li class="slot_router"><router-link class="slot_router" to="/slot" data-title="Slot"><span>Slot</span></router-link></li>
      <li class="casino_router"><router-link class="casino_router" to="/casino" data-title="Canlı Casino"><span>Canlı Casino</span></router-link></li>
      <li class="high_flyer_router"><router-link lang="en" class="high_flyer_router" to="/highflyer" data-title="High Flyer"><div class="label-menu hot">Yeni</div><span>High Flyer</span></router-link></li>
      <li class="other-g" v-if="!isMobile">
        <a href="javascript:;" class="other_router zeppelin_router">
          Diğer Oyunlar
          <svg  viewBox="0 0 15 15" fill="none"> <path d="M7.49988 12L-0.00012207 4L14.9999 4L7.49988 12Z"/> </svg>
          <ul>
            <li class="virtual_router"><router-link class="virtual_router" to="/virtual" data-title="Sanal"><span>Sanal</span></router-link></li>
            <li class="bingo_router"><router-link class="bingo_router" to="/bingo" data-title="Tombala"><span>Tombala</span></router-link></li>
            <li class="beton_router"><router-link class="beton_router" to="/beton" data-title="Betongames"><span>Bet on</span></router-link></li>
            <li class="zeppelin_router"><router-link class="zeppelin_router" to="/zeppelin" data-title="Zeplin"><span>Zeplin</span></router-link></li>
            <li class="aviator_router"><router-link class="aviator_router" to="/aviator" data-title="Aviator"><span>Aviator</span></router-link></li>
            <li class="aviator_router"><router-link target="_blank" class="aviator_router" to="/slot/pragmaticplay/all?game_id=74201&mobile=false" data-title="Aviator"><span>Spaceman</span></router-link></li>
            <li class="aviator_router"><router-link target="_blank" class="aviator_router" to="/slot/smartsoft/all?game_id=75340&mobile=false" data-title="Aviator"><span>JetX</span></router-link></li>
          </ul>
        </a>
      </li>
      
      <slot v-if="isMobile">
            <li class="virtual_router"><router-link class="virtual_router" to="/virtual" data-title="Sanal"><span>Sanal</span></router-link></li>
            <li class="bingo_router"><router-link class="bingo_router" to="/bingo" data-title="Tombala"><span>Tombala</span></router-link></li>
            <li class="beton_router"><router-link class="beton_router" to="/beton" data-title="Betongames"><span>Beton games</span></router-link></li>
            <li class="zeppelin_router"><router-link class="zeppelin_router" to="/zeppelin" data-title="Zeplin"><span>Zeplin</span></router-link></li>
            <li class="aviator_router"><router-link class="aviator_router" to="/aviator" data-title="Aviator"><span>Aviator</span></router-link></li>
      </slot>
      <!-- <li v-if="$auth() && !isMobile"><a href="https://bullbahisetkinlik.com/" target="_blank" data-title="BİLET AL"><span>BİLET AL</span></a></li>  -->
    </ul>
    <div class="bonus-modal" v-if="configSpesific.autoBonus">
        <Modal :isVisible="bonus_modal">
            <template slot="content">
                <div class="close-btn button primary" @click="bonus_modal = false;type = ''">
                          <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                </div>
                <component is="RequestPage" :propType="type" />
            </template>
        </Modal>
    </div>
  </div>
</template>

<script>
import RequestPage from './Request.vue'
export default{
  data(){
    return{
              type: '',
              bonus_modal: false,
    }
  },
  components:{
    RequestPage
  },
  computed:{
    configSpesific(){ 
      return this.$store.getters['special/getConfigSpesific']
    },
    specialMenu(){
      return this.$store.getters['special/getMenu']
    },
    user(){
      return this.$user();
    },
    url(){
      let url = this.$store.getters['special/bonusUrl']
      if(this.$auth()){
        url = url + this.user.username;
      }
      return url
    },
    is_poker(){
      return this.$store.getters.getPokerStatus
    },
  }
}
</script>

<style lang="scss">
  li.other-g{
    position: relative;
    >a:hover{
        ul{
          display: flex !important;
        }
    }
    ul{
        position: absolute;
        display: none !important;
        z-index: 999;
        background: var(--client-header-menu);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        top: 50px;
        left: 0px;
        width: auto !important;
      li{
        a{
          padding: 10px 20px !important;
        }
      }
    }
  }

</style>